__turbopack_context__.v({
  "container": "ClaimedPrize-module__xKre3G__container",
  "drawName": "ClaimedPrize-module__xKre3G__drawName",
  "prizeImage": "ClaimedPrize-module__xKre3G__prizeImage",
  "textSection": "ClaimedPrize-module__xKre3G__textSection",
  "tierIcon": "ClaimedPrize-module__xKre3G__tierIcon",
  "tierRow": "ClaimedPrize-module__xKre3G__tierRow",
  "title": "ClaimedPrize-module__xKre3G__title",
});
